import script from "./FourBgImg.vue?vue&type=script&setup=true&lang=js"
export * from "./FourBgImg.vue?vue&type=script&setup=true&lang=js"

import "./FourBgImg.vue?vue&type=style&index=0&id=10e8c4c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10e8c4c2"]])

export default __exports__